import i18n from "@/plugins/i18n";

function getArchiveColumnsColumns(handlers) {
  return getColumns(handlers, adminArchiveColumns);
}
function getConferenceGalleryColumns(handlers) {
  return getColumns(handlers, conferenceGalleryColumns);
}

function getConferenceArchiveColumnsColumns(handlers) {
  return getColumns(handlers, conferenceArchiveColumns);
}

function getJournalArchiveColumnsColumns(handlers) {
  return getColumns(handlers, journalArchiveColumns);
}

function getMemberArchiveColumnsColumns(handlers) {
  return getColumns(handlers, memberArchiveColumns);
}

function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const adminArchiveColumns = [
  {
    text: i18n.t("label.title"),
    value: "title",
    type: "text",
  },
  {
    text: i18n.t("label.file_name"),
    value: "down_file_name",
    type: "text",
  },
  {
    text: i18n.t("label.created_at"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "cloud_download",
        color: "green",
        key: "download",
        handler: null,
      },
      {
        icon: "delete_forever",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

const conferenceGalleryColumns = [
  {
    text: i18n.t("label.title"),
    value: "title",
    type: "text",
  },
  {
    text: i18n.t("label.created_at"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "edit",
        color: "primary",
        key: "edit",
        handler: null,
      },
      {
        icon: "delete_forever",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

const conferenceArchiveColumns = [
  {
    text: i18n.t("label.order_number"),
    value: "order_number",
    type: "text",
  },
  {
    text: i18n.t("label.title"),
    value: "title",
    type: "text",
  },
  {
    text: i18n.t("label.file_name"),
    value: "down_file_name",
    type: "text",
  },
  {
    text: i18n.t("label.created_at"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "edit",
        color: "primary",
        key: "edit",
        handler: null,
      },
      {
        icon: "cloud_download",
        color: "green",
        key: "download",
        handler: null,
      },
      {
        icon: "delete_forever",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

const journalArchiveColumns = [
  {
    text: i18n.t("label.order_number"),
    value: "order_number",
    type: "text",
  },
  {
    text: i18n.t("label.title"),
    value: "title",
    type: "text",
  },
  {
    text: i18n.t("label.file_name"),
    value: "down_file_name",
    type: "text",
  },
  {
    text: i18n.t("label.created_at"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "edit",
        color: "primary",
        key: "edit",
        handler: null,
      },
      {
        icon: "cloud_download",
        color: "green",
        key: "download",
        handler: null,
      },
      {
        icon: "delete_forever",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

const memberArchiveColumns = [
  {
    text: i18n.t("label.title"),
    value: "title",
    type: "text",
  },
  {
    text: i18n.t("label.file_name"),
    value: "down_file_name",
    type: "text",
  },
  {
    text: i18n.t("label.created_at"),
    value: "created_at",
    type: "text",
  },
  {
    text: i18n.t("label.actions"),
    type: "button",
    actions: [
      {
        icon: "edit",
        color: "primary",
        key: "edit",
        handler: null,
      },
      {
        icon: "cloud_download",
        color: "green",
        key: "download",
        handler: null,
      },
      {
        icon: "delete_forever",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

export {
  getArchiveColumnsColumns,
  getConferenceGalleryColumns,
  getConferenceArchiveColumnsColumns,
  getJournalArchiveColumnsColumns,
  getMemberArchiveColumnsColumns,
};
